import {Component, OnInit} from '@angular/core';
import {LoginInfoComponent} from "../../user/login-info/login-info.component";
import { SiteMenuModel } from 'app/client-core/dtos/site-menu.model';
import { SiteSetupService } from 'app/client-core/services/site-setup';


@Component({

  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {
  menus: Array<SiteMenuModel>;
  constructor(
    private siteSetupService: SiteSetupService
  ) {
    this.menus = siteSetupService._getCachedSiteMenu().filter(m => !m.parentId);
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/navigation.component.ts